export default "__VITE_ASSET__360cbbf7__"